export enum KeyboardKey {
	ArrowDown = 'ArrowDown',
	ArrowLeft = 'ArrowLeft',
	ArrowRight = 'ArrowRight',
	ArrowUp = 'ArrowUp',
	Enter = 'Enter',
	Space = ' ',
}
